<div class="modal-header">
    <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close"><i class="feather x"></i></button>
    <h4 class="modal-title" id="myModalLabel">Comments</h4>
</div>
<div class="modal-body" style="background:#fff;padding-bottom:0;overflow: hidden;">
    <div class="chat-wrapper scrollbars" #scrollMe [scrollTop]="scrollMe.scrollHeight">
        
        <div class="message-bubble" *ngFor="let comment of tracked_item.comments;" [ngClass]="
        {
            'me': comment.sent_by !== null ? comment.sent_by.id === user.id : false,
            'others': comment.sent_by !== null ? comment.sent_by.id !== user.id && comment.sent_by.id !== null : false
        }">
            <div class="avatar avatar-32">
                <div class="avatar-inicitials" initials [name]="comment.sent_by.full_name"></div>
            </div>
    
            <div class="message-bubble-wrapper">
                <div class="message-bubble-title">
                    <span class="title">{{comment.sent_by.full_name}}</span><div class="date">{{comment.date | date:'shortTime'}}</div>
                </div>
                <p class="text">{{comment.message}}</p>
            </div>


        </div>
    </div>
    <div class="chat-input-wrapper border-top" [ngClass]="{'no-text': message === ''}">
        <textarea class="form-control chat-input" rows="1" autosize #inputMessage (keydown.enter)="send_message()" [(ngModel)]="message" autofocus placeholder="Type a message. Shift+Enter adds a line."></textarea>
        <!-- <label class="feather paperclip chat-file"><input type="file"></label> -->
        <i class="feather send" (click)="send_message()"></i>
    </div>
</div>